import axios from "axios";
import React, { useState, useEffect } from "react";
import CreaEquipoCirugiaAmbulatoria from "./CreaEquipos/CreaEquipoCirugiaAmbulatoria";
import Cookies from "universal-cookie";
import DequipoCirugiaAmbulatoria from "../../EliminaEquipos/DequipoCirugiaAmbulatoria";

function EquipoCirugiaAmbulatoria(props) {
  const cookies = new Cookies();
  const [list, setList] = useState([]);

  const obtenerDatos = () => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoCirugiaAmbulatoria?SolicitudId=" +
        props.idSolicitud,
    })
      .then((response) => setList(response.data))
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    obtenerDatos();
  }, []);

  const url = window.location.href;
  const partesURL = url.split("/");
  const nombreRuta = partesURL[partesURL.indexOf("#") + 1];

  return (
    <div className="container">
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">
            Equipo Autoevaluación Cirugía Ambulatoria
          </h6>
        </div>

        <div className="card-body">
          {/* Crear registro */}
          {cookies.get("tipo_Usuario") == 2 &&
          nombreRuta === "ProcesoAutoevaluacion" ? (
            <CreaEquipoCirugiaAmbulatoria
              idSolicitud={props.idSolicitud}
              onSuccess={obtenerDatos}
            />
          ) : null}

          <div className="table-responsive">
            <table className="table table-bordered" width="100%">
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Nombre</th>
                  <th>Servicio</th>
                  <th>Cargo</th>
                  <th>Líder</th>
                  {nombreRuta === "ProcesoAutoevaluacion" && <th>Acciones</th>}
                </tr>
              </thead>

              <tbody>
                {list.map((item) => (
                  <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.nombre}</td>
                    <td>{item.servicio}</td>
                    <td>{item.cargo}</td>
                    <td>{item.lider}</td>

                    {nombreRuta === "ProcesoAutoevaluacion" && (
                      <td>
                        <DequipoCirugiaAmbulatoria
                          id={item.id}
                          onSuccess={obtenerDatos}
                        />
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EquipoCirugiaAmbulatoria;
